<template>
  <section pr-slide-in>
    <div class="j" data-offset="0"></div>
    <div pr-slide-in-body class="stick-body" :style="bodyStyle" :class="direction" :id="id">
      <div pr-slide-in-stay :style="coverStyle">
        <h3 class="q">
          <em>{{ title }}</em>
          {{ titleSub }}
        </h3>
        <slot name="stay" />
      </div>
      <div class="cover" :style="coverStyle">
        <div class="cover-clip" :style="clipStyle">
          <div class="cover-img" :style="imageStyle">
            <video v-if="video" :src="video" muted autoplay loop playsinline />
            <h3 data-p="0.29,0.7" data-y="0,-100" data-a="1,0">
              <em>{{ title }}</em>
              {{ titleSub }}
            </h3>
            <GridBase alpha50>
              <slot />
            </GridBase>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { applyRatio, getOffsetTop, getScrollBody } from "@/utils";
import responsive from "@/utils/responsive";
import GridBase from "@/views/components/GridBase";

export default {
  name: "PrSlideIn",
  components: { GridBase },
  data() {
    return {
      bodyStyle: {},
      coverStyle: {},
      imageStyle: {},
      clipStyle: {},
      stickContainer: null,
      stickBody: null,
      innerList: [],
      fixed: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    titleSub: {
      type: String,
      default: "",
    },
    video: { type: String },
    img: { type: String },
    direction: { default: "r2l" },
    id: { type: String },
  },
  computed: {},
  watch: {
    sv: "render",
  },
  methods: {
    inner(r) {
      applyRatio(this.innerList, r);
    },
    render() {
      if (!this.$el) return;
      const sv = this.sv;
      const d = sv - getOffsetTop(this.$el);
      const h = this.$el.offsetHeight * 0.5;
      if (d < 0 || d > h) {
        if (this.fixed) {
          this.$el.appendChild(this.stickBody);
          this.fixed = false;
          this.$store.commit("setFix", false);
        }
      } else {
        if (!this.fixed) {
          this.stickContainer.appendChild(this.stickBody);
          this.fixed = true;
          this.$store.commit("setFix", true);
        }
      }
      if (d < -window.innerHeight * 2 || d > window.innerHeight * 2) return;
      this.inner(d / h);

      const t = this.sect === "sm" || this.sect === "md" ? 55 : 64;
      const w = getScrollBody().clientWidth;
      const y = d > h ? h + t : t;
      const ih = h - t;
      let cw;

      const R = h * 0.5;
      if (d < 0) {
        cw = 0.5 * w;
      } else if (d > R) {
        cw = w;
      } else {
        cw = w * 0.5 + (w * 0.5 * d) / R;
      }

      this.bodyStyle = {};
      this.coverStyle = { height: ih + "px", top: y + "px" };

      this.clipStyle = { width: cw + "px", height: ih + "px" };
      this.imageStyle = { width: w + "px", height: ih + "px" };

      if (this.img) this.imageStyle.backgroundImage = `url(${this.img})`;
    },
  },
  mounted() {
    this.stickContainer = document.querySelector(".stick-container");
    this.stickBody = this.$el.querySelector(".stick-body");
    this.innerList = this.$el.querySelectorAll("[data-p]");
    responsive.addListener(this.render);
  },
  beforeDestroy() {
    responsive.removeListener(this.render);
    this.stickBody.parentNode.removeChild(this.stickBody);
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

[pr-slide-in] {
  .h(200vh);

  .j {
    .abs;
    .t(100vh);
  }
}

[pr-slide-in-body] {
  .bold;

  [pr-slide-in-stay] {
    .abs;
    .wf;
  }

  h3 {
    .calibre;
    .fs(48);
    .semi-bold;
    .tc;
    .mt(100);
    color: #fff !important;
    .wf;
  }

  .cover {
    z-index: 2;
    .abs;
    .wf;
    .lt;

    .cover-clip {
      .abs;
      overflow: hidden;

      .cover-img {
        .wf;
        .abs;
        color: #fff;
        .-box;
        .bg-c;
        .cover;

        video {
          .abs;
          .lt(50%, 50%);
          .min-h(100%);
          .min-w(100%);
          transform: translate(-50%, -50%);
        }

        h3 {
          color: #fff !important;
          .rel;
        }

        [grid-base],
        [grid-base-content] {
          .abs;
          .lt;
          .wh(100%);
        }
      }
    }
  }

  &.r2l {
    .cover-clip {
      .r(0);

      .cover-img {
        .r(0);
      }
    }
  }

  &.l2r {
    .cover-clip {
      .l(0);

      .cover-img {
        .l(0);
      }
    }
  }

  .en & {
    .semi-bold;

    .cover {
      .cover-clip {
        .cover-img {
          .cnt {
            h4 {
              .fs(44, 46, 0);
            }

            p {
              .fs(22, 28, 0);
            }
          }
        }
      }
    }
  }

  @media (min-width: @screen-md-min) {
    h3 {
      .fs(64);
    }

    .cover {
      .cover-clip {
        .cover-img {}
      }
    }
  }

  @media (min-width: @screen-lg-min) {
    h3 {
      .fs(76, 76, 0);
      .mt(50vh);
      .rel;
      .t(-38);
    }

    .cover {
      .cover-clip {
        .cover-img {}
      }
    }
  }

  @media (min-width: @screen-xxl-min) {
    h3 {
      .fs(120);
      .t(-60);
    }

    .cover {
      .cover-clip {
        .cover-img {}
      }
    }

    .en & {
      .semi-bold;

      .cover {
        .cover-clip {
          .cover-img {}
        }
      }
    }
  }
}
</style>
